import Head from 'next/head'
import { ReactNode } from 'react'

import BasicSection from '~/components/BasicSection'
import { PAGE_TITLE_PREFIX } from '~/components/constants'
import Layout from '~/components/Layout'
import Hero from '~/components/secondaryPage/Hero'
import HowItWorks from '~/components/secondaryPage/HowItWorks'
import Overview from '~/components/secondaryPage/Overview'
import Summary from '~/components/secondaryPage/Summary'
import { Navigation, SecondaryPage as SecondaryPageType } from '~/lib/sanity.queries'

export default function SecondaryPage({
  content,
  title,
  navigation,
  howItWorksArtwork,
}: {
  content: SecondaryPageType
  title: string
  navigation: Navigation
  howItWorksArtwork?: ReactNode[]
}) {
  const pageTile = `${PAGE_TITLE_PREFIX} ${title}`
  return (
    <>
      <Head>
        <title>{pageTile}</title>
      </Head>
      <Layout navigation={navigation}>
        <Hero content={content.hero} />
        <Overview content={content.overviewCards} title={title} />
        <div className="h-[300px] md:h-[700px] relative w-full -mb-40 -z-10">
          <video
            src="/videos/services-hero.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="absolute w-full h-full object-contain"
            poster="/images/services-hero.webp"
          >
            Your browser does not support the video tag.
          </video>
        </div>
        <BasicSection titleSize="h2" content={content.callOut} />
        <HowItWorks
          content={content.howItWorks}
          howItWorksArtwork={howItWorksArtwork}
        />
        <Summary content={content.summary} />
        <BasicSection
          content={content.cta}
          start="top bottom+=25%"
          end="bottom top-=100%"
        />
      </Layout>
    </>
  )
}
